// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5fc6b36b","617":"d6c7ccf3","847":"c1a3cd08"}[chunkId] + ".chunk.js";
};